import moment from 'moment';
import {ExpirationKeys} from 'lib/SettingsUtil';

/**
 * Regex for checking whether or not a key is a comparable property preference
 */
export const comparablePreferenceKeyRegex = /comparable(Sales|Listings|Rentals)\.properties\.\d+:.*/i;

export const expirablePreferenceFields = [
  'propertyType',
  'bedrooms',
  'bathrooms',
  'carSpaces',
  'landArea',
  'floorArea',
  'salePrice',
  'listingPrice',
  'firstPublishedPrice',
  'latestPublishedPrice',
  'propertyPhotoUriSelectedIndex',
  'featuredPhotos',
];

const defaultExpiration = { [ExpirationKeys.PROPERTY_PREFERENCES_EXPIRATION]: 'PT72H' };

/**
 * Checks against the preference created timestamp and preference keys that should expire
 * @param preferences {{key: string, value: string, created: string}[]} Raw data returned from V2 property preferences call
 * @param settings {{expiration: {propertyPreferences: string}}} Settings object loaded from redux state
 * @returns {{key: string, value: string, created: string}[]} Preferences that have not been created after the expiration period
 */
export function filterExpiredPreferences(
  preferences,
  settings = { expiration: defaultExpiration }
) {
  try {
    const {
      expiration: { [ExpirationKeys.PROPERTY_PREFERENCES_EXPIRATION]: propertyPreferences } = defaultExpiration,
    } = settings;
    const expirationDuration = moment.duration(propertyPreferences);
    if (!expirationDuration.isValid() || expirationDuration.asMilliseconds() <= 0) {
      return preferences;
    }
    const earliestAcceptedMoment = moment.utc().subtract(expirationDuration);
    return preferences.filter((pref) => {
      if (
        comparablePreferenceKeyRegex.test(pref.key) &&
        expirablePreferenceFields.findIndex((field) => pref.key.includes(field)) > -1
      ) {
        const createdMoment = moment.utc(pref.created);
        return createdMoment.isAfter(earliestAcceptedMoment);
      }
      return true;
    });
  } catch (e) {
    // Fail and return back all the preferences
    console.error(e);
    return preferences;
  }
}
